// extracted by mini-css-extract-plugin
var _1 = "TopSearchesTitle-tXx3p";
var _2 = "TopSearchesTitleContainer-j3NkI";
export { _1 as "TopSearchesTitle", _2 as "TopSearchesTitleContainer" }
